import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function BreadcrumbBar() {
  const location = useLocation();
  const pathname = location.pathname;

  // Supprime "/cfp" et divise les segments
  const pathSegments = pathname
    .replace(/^\/cfp/, "")
    .split("/")
    .filter(Boolean)
    // ignore les segments purement numériques
    .filter((segment) => !/^\d+$/.test(segment));

  const breadcrumbs = [
    { name: "Accueil", href: "/cfp" },
    ...pathSegments.map((segment, index) => {
      const href = "/cfp/" + pathSegments.slice(0, index + 1).join("/");

      const formattedName = segment
        .replace(/_/g, " ")
        .replace(/^\w/, (c) => c.toUpperCase());

      return { name: formattedName, href };
    }),
  ];

  return (
    <div className="px-6 py-1 text-gray-700 bg-white border-b border-gray-200">
      <nav className="flex items-center space-x-2 text-sm">
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <div key={breadcrumb.href} className="flex items-center">
              {index === 0 && <Home className="w-4 h-4 mr-1" />}

              {!isLast ? (
                <Link
                  to={breadcrumb.href}
                  className="transition-colors hover:text-gray-900"
                >
                  {breadcrumb.name}
                </Link>
              ) : (
                <span className="text-gray-500">{breadcrumb.name}</span>
              )}

              {!isLast && (
                <ChevronRight className="w-4 h-4 mx-2 text-gray-400" />
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
}
